const FaqSvg = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0007 20.1654C16.0633 20.1654 20.1673 16.0613 20.1673 10.9987C20.1673 5.93609 16.0633 1.83203 11.0007 1.83203C5.93804 1.83203 1.83398 5.93609 1.83398 10.9987C1.83398 16.0613 5.93804 20.1654 11.0007 20.1654Z"
        stroke="#2A2D31"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33203 8.2515C8.54754 7.63886 8.97292 7.12226 9.53282 6.7932C10.0927 6.46414 10.751 6.34386 11.3911 6.45365C12.0312 6.56344 12.6118 6.89623 13.03 7.39307C13.4483 7.8899 13.6772 8.51873 13.6762 9.16817C13.6762 11.0015 10.9262 11.9182 10.9262 11.9182"
        stroke="#2A2D31"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 15.582H11.01"
        stroke="#2A2D31"
        stroke-width="1.375"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FaqSvg;
